export const tenantsMock = [
  {
    id: 'tenant-root-axodus',
    displayName: 'Axodus Root Protocol',
    slug: 'axodus-root',
    type: 'root',
    governanceStatus: 'protocol-root',
    federationTier: 'root',
    primaryChain: 'Ethereum Sepolia',
    enabledModules: ['governance', 'defi', 'academy', 'marketplace', 'acs', 'mining', 'dex', 'lottery', 'mcps'],
    disabledModules: ['trading'],
    roles: ['protocol-observer', 'constitutional-reviewer'],
    permissions: ['view-protocol', 'view-governance', 'view-treasury-read-model'],
    maturity: 'prototype',
    riskState: 'low',
    acsState: 'online',
    treasuryMode: 'protocol-read-only',
    executionMode: 'read-only',
    restrictions: ['execution-disabled-in-frontend', 'treasury-actions-governance-gated'],
    createdAt: '2026-05-01T00:00:00.000Z',
    updatedAt: '2026-05-27T00:00:00.000Z',
  },
  {
    id: 'tenant-company-bba',
    displayName: 'BBA Agency Workspace',
    slug: 'bba-agency',
    type: 'agency',
    governanceStatus: 'compliant',
    federationTier: 'partner',
    primaryChain: 'Base',
    enabledModules: ['business', 'marketplace', 'academy', 'acs', 'governance'],
    disabledModules: ['dex', 'lottery', 'trading'],
    roles: ['tenant-operator', 'publisher', 'business-reviewer'],
    permissions: ['view-business', 'view-marketplace', 'create-preview-draft', 'view-acs-review'],
    maturity: 'prototype',
    riskState: 'moderate',
    acsState: 'review-required',
    treasuryMode: 'tenant-read-only',
    executionMode: 'preview',
    restrictions: ['publisher-actions-preview-only', 'treasury-settlement-disabled'],
    createdAt: '2026-05-05T00:00:00.000Z',
    updatedAt: '2026-05-27T00:00:00.000Z',
  },
  {
    id: 'tenant-subdao-governance-labs',
    displayName: 'Governance Labs Sub-DAO',
    slug: 'governance-labs',
    type: 'sub-dao',
    governanceStatus: 'compliant',
    federationTier: 'sovereign',
    primaryChain: 'Ethereum Sepolia',
    enabledModules: ['governance', 'business', 'acs', 'academy', 'marketplace'],
    disabledModules: ['trading', 'lottery'],
    roles: ['dao-member', 'proposal-reviewer', 'tenant-admin'],
    permissions: ['view-tenant', 'view-proposals', 'draft-proposal-preview', 'view-operations'],
    maturity: 'api-ready',
    riskState: 'low',
    acsState: 'online',
    treasuryMode: 'tenant-read-only',
    executionMode: 'preview',
    restrictions: ['execution-requires-wallet-and-governance-guards'],
    createdAt: '2026-05-08T00:00:00.000Z',
    updatedAt: '2026-05-27T00:00:00.000Z',
  },
  {
    id: 'tenant-sandbox-product',
    displayName: 'Sandbox Product Lab',
    slug: 'sandbox-product-lab',
    type: 'sandbox',
    governanceStatus: 'sandbox',
    federationTier: 'sandbox',
    primaryChain: 'Polygon',
    enabledModules: ['academy', 'marketplace', 'business', 'acs'],
    disabledModules: ['defi', 'dex', 'lottery', 'mining', 'trading'],
    roles: ['sandbox-builder'],
    permissions: ['view-sandbox', 'create-preview-draft'],
    maturity: 'mock',
    riskState: 'sandbox',
    acsState: 'sandbox',
    treasuryMode: 'simulation',
    executionMode: 'simulation',
    restrictions: ['mock-only', 'no-live-contracts', 'no-treasury-routing'],
    createdAt: '2026-05-12T00:00:00.000Z',
    updatedAt: '2026-05-27T00:00:00.000Z',
  },
  {
    id: 'tenant-restricted-market',
    displayName: 'Restricted Market Review',
    slug: 'restricted-market-review',
    type: 'company',
    governanceStatus: 'under-review',
    federationTier: 'restricted',
    primaryChain: 'Arbitrum',
    enabledModules: ['governance', 'acs', 'marketplace'],
    disabledModules: ['business', 'defi', 'dex', 'lottery', 'mining', 'trading'],
    roles: ['observer'],
    permissions: ['view-tenant', 'view-review-status'],
    maturity: 'mock',
    riskState: 'restricted',
    acsState: 'restricted',
    treasuryMode: 'blocked',
    executionMode: 'executable-disabled',
    restrictions: ['governance-review-required', 'acs-restricted', 'marketplace-publishing-blocked'],
    createdAt: '2026-05-18T00:00:00.000Z',
    updatedAt: '2026-05-27T00:00:00.000Z',
  },
];

export const defaultTenantId = 'tenant-root-axodus';
